import { z } from "zod";
import { vocabularySnapshotV3Schema } from "./versions/v3.ts";

export {
  vocabularySnapshotV3WordTypeSchema as wordTypeSchema,
  vocabularySnapshotV3WordEntrySchema as wordEntrySchema,
  vocabularySnapshotV3MeaningCardSchema as meaningCardSchema,
  vocabularySnapshotV3MeaningRelationSchema as meaningRelationSchema,
  vocabularySnapshotV3ExerciseSetSchema as exerciseSetSchema,
  vocabularySnapshotV3PracticeStateSchema as practiceStateSchema,
  vocabularySnapshotV3Schema as vocabularySnapshotSchema,
} from "./versions/v3.ts";

export const backupEnvelopeSchema = z
  .object({
    format: z.literal("vocably-backup"),
    formatVersion: z.literal(1),
    exportedAt: z.string().min(1),
    snapshot: vocabularySnapshotV3Schema,
  })
  .strict();

export const settingsSchema = z.object({
  aiMode: z.enum(["gemini", "sample", "http"]),
  httpBaseUrl: z.string().optional(),
  installHintDismissed: z.boolean().optional(),
});

export type SettingsRecord = z.infer<typeof settingsSchema>;
export type BackupEnvelope = z.infer<typeof backupEnvelopeSchema>;
